import {Directive, DoCheck, Input, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {FeatureFlagsService} from "./feature-flags.service";

@Directive({
  selector: '[featureOn]'
})
export class FeatureOnDirective implements OnInit, DoCheck {

  @Input()
  public featureOn: string;

  private isOn = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagsService: FeatureFlagsService
  ) { }

  ngOnInit() {
    if (!this.featureOn) {
      throw new Error('Attribute "featureOn" should be supplied');
    }
    this.shouldRender();
  }

  ngDoCheck() {
    if (this.isOn !== this.featureFlagsService.isOn(this.featureOn)) {
      this.shouldRender();
    }
  }

  private shouldRender() {
    this.isOn = this.featureFlagsService.isOn(this.featureOn);
    if (this.isOn) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

}
